export default __webpack_public_path__ + "static/inmemoryheader-ce1fa2896e14ee9a8ef6da71343edcd4.png";